export function loadDemoSymptoms() {
  return [
    {
      id: '1',
      user_id: 'demo-user-id',
      name: 'Headache',
      category: 'neurological',
      severity: 5,
      notes: 'Mild headache after work',
      triggers: ['stress', 'eye strain'],
      related_conditions: ['1'],
      ai_suggested: false,
      recorded_at: new Date().toISOString(),
      created_at: new Date().toISOString()
    }
  ];
}
